exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".gallery[data-v-172e7c2c]{display:flex}.gallery .wrapper[data-v-172e7c2c]{flex:1;box-sizing:border-box;padding:2px 1px}.gallery .wrapper img[data-v-172e7c2c]{display:block;width:auto;border:0;border-radius:2px;cursor:pointer;overflow:hidden}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-172e7c2c","scoped":true,"hasInlineConfig":false}!./node_modules/stylus-loader!./assets/vue/components/images/components/gallery.styl
// module id = 531
// module chunks = 0